import { create } from "zustand";

import { marketingColors } from "UI/colors";

// Zustand store for managing line animations
const useLineStore = create((set) => ({
  lines: [],
  drawLine: (from, to, options = {}) => {
    const id = Math.random().toString(36).substr(2, 9);
    const line = {
      id,
      from,
      to,
      color: options.color || marketingColors.red,
      duration: options.duration || 3600,
      variant: options.variant || "arrow", // "arrow" or "squiggle"
      createdAt: Date.now(),
    };

    set((state) => ({
      lines: [...state.lines, line],
    }));

    // Auto-remove after animation completes
    setTimeout(() => {
      set((state) => ({
        lines: state.lines.filter((l) => l.id !== id),
      }));
    }, line.duration);
  },
  removeLine: (id) =>
    set((state) => ({
      lines: state.lines.filter((l) => l.id !== id),
    })),
}));

const useDrawLine = () => useLineStore((s) => s.drawLine);

export { useDrawLine };
export default useLineStore;
